module.exports = __webpack_public_path__ + "img/fob_symbol_red.fbbd406b.svg";